module.exports = __webpack_public_path__ + "static/media/iconNota.f2c9eaf7.svg";